<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="pmos"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="500px"
          dataKey="msaipExceptionDisputeId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          [lazy]="true"
          (onLazyLoad)="loadSearchContent($any($event))"
          (onPage)="pageChange()"
          [totalRecords]="totalRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <div class="search-box-container">
                <div class="search-box mr-2">
                  <input
                    type="text"
                    pInputText
                    size="30"
                    placeholder="Search"
                    (input)="searchOrFilterEngagements()"
                    style="width: 340px"
                    [(ngModel)]="searchAndFilterInput.searchString" />
                  @if (searchAndFilterInput.searchString) {
                    <button
                      pButton
                      pRipple
                      type="button"
                      icon="pi pi-times"
                      (click)="clearSearchText()"
                      class="close-button p-button-rounded p-button-text p-0">
                      Clear
                    </button>
                  }
                </div>
                <i class="fa fa-search ml-2"></i>
                <span class="pageInfo visiblelg resettble">{{
                  currentPageInfo
                }}</span>
              </div>
              <span style="float: right; position: relative; bottom: 30px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr>
              <th
                [pSortableColumn]="'MsaipExceptionDisputeId'"
                class="colmedium">
                Exception/Dispute ID<p-sortIcon
                  [field]="'msaipExceptionDisputeId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'RequestType'" class="colsmall">
                Request Type<p-sortIcon [field]="'requestType'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'RequestReason'" class="collarge">
                Request Reason
                <p-sortIcon [field]="'requestReason'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'Action'" class="colmedium">
                Action<p-sortIcon [field]="'action'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'RequestKey'" class="colmedium">
                Requested Workshop ID<p-sortIcon
                  [field]="'requestKey'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'WorkshopName'" class="collarge">
                Requested Workshop Name<p-sortIcon
                  [field]="'workshopName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'CustomerOrgName'" class="colmedium">
                Customer Org<p-sortIcon
                  [field]="'customerOrgName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'PartnerInputParnterName'"
                class="colmedium">
                Partner Name<p-sortIcon
                  [field]="'partnerInputParnterName'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'PartnerInputMPNId'" class="colsmall">
                Partner ID<p-sortIcon
                  [field]="'partnerInputMPNId'"></p-sortIcon>
              </th>

              <th
                [pSortableColumn]="'PartnerInputCustomerTPId'"
                class="colmedium">
                TPID<p-sortIcon
                  [field]="'partnerInputCustomerTPId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'Status'" class="colmedium">
                Status<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.msaipExceptionDisputeId" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.requestType" />
              </th>
              <th class="dashtable collarge">
                <p-multiSelect
                  #tak
                  appendTo="body"
                  [options]="msaipRequestReasonDrpdwn"
                  placeholder="Reason"
                  [(ngModel)]="searchAndFilterInput.requestReasons"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colmedium">
                <p-multiSelect
                  #tak
                  appendTo="body"
                  [options]="msaipActionsDrpdwn"
                  placeholder="Action"
                  [(ngModel)]="searchAndFilterInput.actions"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.requestKey" />
              </th>
              <th class="dashtable collarge">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.workshopName" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.customerOrgName" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputParnterName" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputMPNId" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputCustomerTPId" />
              </th>
              <th class="dashtable colmedium">
                <p-multiSelect
                  #tak
                  appendTo="body"
                  [options]="msaipExceptionDisputeStatusDrpdwn"
                  placeholder="Status"
                  [(ngModel)]="searchAndFilterInput.statuses"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }}">
                  <a class="editlink">{{ rowData.msaipExceptionDisputeId }}</a>
                </span>
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.requestType
                  }}"
                  >{{ rowData.requestType }}</span
                >
              </td>
              <td class="collarge">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.requestReason
                  }}"
                  >{{ rowData.requestReason }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.action
                  }}"
                  >{{ rowData.action }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.requestKey
                  }}"
                  >{{ rowData.requestKey }}</span
                >
              </td>
              <td class="collarge">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.workshopName
                  }}"
                  >{{ rowData.workshopName }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.customerOrgName
                  }}"
                  >{{ rowData.customerOrgName }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.partnerInputParnterName
                  }}"
                  >{{ rowData.partnerInputParnterName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.partnerInputMPNId
                  }}"
                  >{{ rowData.partnerInputMPNId }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.partnerInputCustomerTPId
                  }}"
                  >{{ rowData.partnerInputCustomerTPId }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.msaipExceptionDisputeId }} : {{
                    rowData.status
                  }}"
                  >{{ rowData.status }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
